import type { IActionItem } from '@model/actionItem';
import type { IAIReport } from '@model/aiReport';

export const getAiControls = (
  actionItem?: IActionItem,
  activeReport?: IAIReport,
  canManageData?: boolean,
) => {
  if (!actionItem?.id) return {};

  const isWwAi = actionItem.type === 'waitesWireless';
  const aiState = +actionItem.state;
  const isOnboardingMockupAi = +actionItem.id === -1;

  const isArchive = aiState === 5 || aiState === 9;
  const isSnoozed = aiState === 3;
  const isNoActions = !!actionItem.is_no_actions;
  const isOpenAi = [0, 2, 7, 10].includes(aiState);
  const isVerifyingState = aiState === 6;
  const isDontCreateWo = +actionItem.user_id === 999 && aiState === 2;
  const isReportSubmitted = !!activeReport?.id || isNoActions;
  const isTroubleshootingHold = +actionItem.is_troubleshooting_hold === 1;
  const isMote = actionItem.equipment_type === 'mote';
  const isSensor = actionItem.equipment_type === 'sensor';
  const isInstPointTypeBoolean = actionItem.installation_point.point_type === 'boolean';
  const hasReport = !!activeReport?.id;

  const mainCheck = isArchive || isTroubleshootingHold || isDontCreateWo || !canManageData;

  const checkEditBtn = !mainCheck && hasReport ? isVerifyingState : isNoActions && !isOpenAi && !isSnoozed;
  const checkResubmitBtn = !mainCheck && isOpenAi && (hasReport || isNoActions);

  const showReplaceSensor =
    canManageData &&
    !isArchive &&
    !!actionItem.is_replace_equipment &&
    (isSensor || isMote) &&
    !isInstPointTypeBoolean;

  const showCommentForm =
    (!isArchive &&
      (![3, 4, 6].includes(+aiState) || isTroubleshootingHold) &&
      !isInstPointTypeBoolean &&
      canManageData) ||
    isOnboardingMockupAi;

  return {
    showCancelSnoozeBtn: isSnoozed && !isTroubleshootingHold && !isDontCreateWo && canManageData,
    showSnoozeBtn:
      (!isSnoozed && !isVerifyingState && !isArchive && !isTroubleshootingHold && canManageData) ||
      isOnboardingMockupAi,
    showCloseBtn: mainCheck ? false : hasReport ? isArchive : !isNoActions && aiState !== 3,
    showEditReportBtn: checkEditBtn && !isWwAi && !isArchive,
    showWwEditReportBtn: checkEditBtn && isWwAi && !isArchive,
    showResubmitReportBtn: checkResubmitBtn && !isWwAi,
    showWwResubmitReportBtn: checkResubmitBtn && isWwAi,
    showCancelAndCloseBtn: isDontCreateWo && canManageData,
    showReplaceSensor,
    showCommentForm,
    isWwAi,
    isArchive,
    isNoActions,
    isReportSubmitted,
    isMote,
    isSensor,
    isInstPointTypeBoolean,
    hasReport,
    type: actionItem.type,
    isOnboardingMockupAi,
  };
};
